import withType from 'components/common/hoc/withType'
import BreadcrumbPanel from './BreadcrumbPanel'

export default withType({ type: 'BreadcrumbPanel' })(BreadcrumbPanel)
